import {
  getVideoProgressPollUrl,
  sendApiRequest,
} from '##/services/tenApi/apirequest';
import { config } from '##/services/store/store';
import { isLoggedIn } from '##/services/authentication/Authentication';
import { sendErrorToTealium } from '##/components/Error';
import {
  TealiumErrorCode,
  TealiumErrorContext,
} from '##/services/analytics/Tealium/TealiumErrorTypes';
import { ContinueWatchingResponse, PastProgressResponse } from './types';

export const sendProgressUpdate = (
  videoCode: string,
  progress: number,
  completed: boolean,
): Promise<void> => {
  if (!isLoggedIn()) return Promise.resolve();

  const fullUrl = getVideoProgressPollUrl();
  return sendApiRequest(
    fullUrl,
    'POST',
    {},
    { videoCode, progress, completed },
  );
};

export const getContinueWatchingData = async (): Promise<ContinueWatchingResponse> => {
  const {
    watchHistoryApiEndpoint: continueWatchingEndpoint,
  } = config.$get().app.userEndpoints;
  try {
    return await sendApiRequest<ContinueWatchingResponse>(
      continueWatchingEndpoint,
    );
  } catch (err) {
    sendErrorToTealium({
      errorCode: TealiumErrorCode.FetchWatchHistory,
      errorContext: TealiumErrorContext.API,
      errorDetail: JSON.stringify(err),
      errorSource: continueWatchingEndpoint,
      errorMessage: '',
    });
    throw err;
  }
};

export const getPastProgressData = async (): Promise<PastProgressResponse> => {
  const { progressApiEndpoint } = config.$get().app.userEndpoints;
  try {
    return await sendApiRequest<PastProgressResponse>(progressApiEndpoint);
  } catch (err) {
    sendErrorToTealium({
      errorCode: TealiumErrorCode.FetchWatchHistory,
      errorContext: TealiumErrorContext.API,
      errorDetail: JSON.stringify(err),
      errorSource: progressApiEndpoint,
      errorMessage: '',
    });
    throw err;
  }
};
